<template>
    <div class="search_block" id="searchRow">
        <div class="row filter m-0" id="searchRestaurants">
            <div :class="{'col-sm-6 col-xs-6 nopadding': !is_on_sidebar, 'mb-2': is_on_sidebar}">
                <input type="text"
                       class="form-control main-enter"
                       id="company-video"
                       name="company"
                       :placeholder="keyword_placeholder_trans"
                       v-model="selected_keyword"
                       @blur="closeMenu"
                       ref="keyword_input"
                       v-on:click="keywords_loading = true; openMenu(); getKeywordAutoComplete()"
                       @keyup.enter="makeSearch"
                       @keyup="keywords_loading = true; getKeywordAutoComplete()"/>

                <div class="col-md-12 search_results p-l-r-0" v-if="menu_open">
                    <div v-if="keywords_loading" class="text-center">
                        <img src="/assets/img/ball-triangle.svg" class="svg-loader" alt="Loading"/>
                    </div>
                    <div v-if="!keywords_loading && show_suggestions && suggested_searches.length > 0">
                        <div class="col-md-12 separator_text">
                            <h4 class="ui horizontal divider header">
                                {{ suggested_searches_trans }}
                            </h4>
                        </div>

                        <div class="col-md-6 col-xs-12 suggested_search_holder"
                             v-for="suggested_search in suggested_searches"
                             @click="setKeyword(suggested_search.name)">
                            <div class="col-md-12 suggested_search" @click="setKeyword(suggested_search.name)">
                                {{ suggested_search.name }}
                            </div>
                        </div>
                    </div>
                    <div v-else-if="!keywords_loading && keywords.length > 0">
                        <div
                            class="single_search_result"
                            v-for="keyword in keywords"
                            @click="setKeyword(keyword)">
                            {{ keyword }}
                        </div>
                    </div>
                    <div v-else-if="!keywords_loading">
                        <h5 class="text-center no_results_message">{{ no_suggestions_trans }}</h5>
                    </div>
                </div>

            </div>

            <div :class="{'col-sm-6 col-xs-6 nopadding': !is_on_sidebar, 'mb-2': is_on_sidebar}">
                <HereAddressLookup
                    @address="getAddressData"
                    @searching-location="setLoading"
                    id="citySelect"
                    :placeholder="city_placeholder ? city_placeholder : city_placeholder_trans"
                    :app_key="here_maps_api_key"
                    :city-not-selected="cityNotSelected"
                    ref="city_input"/>
            </div>

            <br v-if="!is_on_sidebar"><br v-if="!is_on_sidebar">

            <div class="col-sm-6 col-xs-12 nopadding w-100">
                <div class="mt-5">
                    <button v-for="(search, index) in searchLists" :key="index" class="btn btn-search-list">
                        <span class="search-list-label">{{ search.text }}</span>
                        <span @click="removeSearch(search)" class="lnr lnr-cross"></span>
                    </button>
                </div>
                <div class="filter-actions filter-column my-1">
                    <div>
                        <div class="filter-and-reset">
                            <button class="btn btn-filter mr-5 d-none" style="height: 37px" id="filtersToggle">
                                <span>{{ filters_trans }}</span>
                                <span class="lnr lnr-chevron-down"></span>
                            </button>
                            <a href="#filters" class="visible-xs visible-sm mr-5">
                                <i class="lnr lnr-funnel"></i>
                                {{ filters_trans }}
                            </a>
                            <a href="#" onclick="event.preventDefault();" @click="clearFields()">
                                <i class="lnr lnr-cross-circle"></i>
                                <span id="filter-reset-text">{{ trans_restaurant_reset | oneWord }}</span>
                            </a>
                        </div>
                    </div>
                    <div class="hidden-xs" v-if="filter_text_trans">
                        {{ filter_text_trans }}
                    </div>
                    <div>
                        <div class="toggle-switch mr-5  mt-1" id="div-show-map"
                             style="display: inline-flex; justify-content: center; align-items: center;">
                            <label for="show-map" class="mr-3 mb-0">{{ show_map }}</label>
                            <input type="checkbox" class="toggleCheckbox" id="show-map" name="showmap"/>
                            <label class="toggleLabel pull-right mb-0" for="show-map">Show Map</label>
                        </div>
                    </div>
                    <button @click="makeSearch" type="button" class="btn btn-primary" :class="{'sidebar-w-100': is_on_sidebar}" :disabled="loading">
                        <div v-if="loading" class="spinner"></div>
                        <div v-else>
                            <i class="lnr lnr-magnifier" style="color: #fff;"></i> {{ button_trans }}
                        </div>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import helper from '../helper';
import search from '../search';
import HereAddressLookup from '../components/HereAddressLookup.vue'

export default {
    mixins: [
        helper,
        search
    ],

    components: {
        HereAddressLookup
    },

    props: {
        button_trans: {
            type: String,
            default: 'Search'
        },
        not_location_selected: {
            type: String,
            default: 'Please select a location'
        },
        keyword_placeholder_trans: {
            type: String,
            default: 'Search'
        },
        city_placeholder_trans: {
            type: String,
            default: 'City'
        },
        suggested_searches_trans: {
            type: String,
            default: 'Suggested Searches'
        },
        no_suggestions_trans: {
            type: String,
            default: 'No suggestions'
        },
        trans_restaurant_reset: {
            type: String,
            default: 'Reset'
        },
        show_map: {
            type: String,
            default: 'Show Map'
        },
        filters_trans: {
            type: String,
            default: 'Filters'
        },
        filter_text_trans: {
            type: String,
            default: ''
        },
        range_error_location: {
            type: String,
            default: 'Please enter the address first'
        },
        auto_complete_route: {
            type: String,
            required: true
        },
        build_search_route: {
            type: String,
            required: true
        },
        restaurant_route: {
            type: String,
            required: true
        },
        here_maps_api_key: {
            type: String,
            required: true
        },
        is_on_sidebar: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            address: '',
            keywords: false,
            selected_keyword: '',
            suggested_searches: [],
            delay: 250,
            menu_open: false,
            show_suggestions: true,
            keywords_loading: false,
            search_terms: [],
            search_amenities: [],
            formatted_value: '',
            search_rating: '',
            search_range: '',
            searchLists: [],
            loading: false,
            city_placeholder: null,
            cityNotSelected: false,
        }
    },

    watch: {
        selected_keyword() {
            this.show_suggestions = !this.selected_keyword.length;
        }
    },

    filters: {
        oneWord(value) {
            let windowWidth = window.innerWidth;

            if (windowWidth <= 576) {
                return value.split(' ')[0];
            }

            return value;
        }
    },

    methods: {
        setLoading(payload) {
            this.loading = payload;
        },
        makeSearch() {
            let self = this;

            this.loading = true;

            if (this.address.locality && (
                this.address.locality ||
                this.selected_keyword.length ||
                this.search_terms.length ||
                this.search_rating.length ||
                this.search_amenities.length ||
                this.search_range.length)
            ) {
                if (this.search_range && !this.address.locality) {
                    return iziToast.show({
                        title: this.range_error_location,
                        color: 'red' // blue, red, green, yellow
                    });
                }

                let search_obj = {
                    'company_search': this.selected_keyword,
                    'search_city': this.address,
                    'search_terms': this.search_terms,
                    'search_amenities': this.search_amenities,
                    'search_rating': this.search_rating,
                    'search_range': this.search_range,
                };

                this.suggested_searches.forEach(function (terms) {
                    if (terms.name === self.selected_keyword) {
                        search_obj.search_terms.push(terms.slug);
                        search_obj.company_search = '';
                    }
                });

                axios.post(this.build_search_route, search_obj)
                    .then(function (response) {
                        self.loading = false;

                        if (response.data.status === 'success') {
                            window.location.href = response.data.url;
                        } else if (response.data.status === 'not_supported') {
                            iziToast.show({
                                title: response.data.message,
                                color: response.data.code  // blue, red, green, yellow
                            });
                        }
                    })
                    .catch(function (error) {
                        self.loading = false;
                        console.log(error);
                    });
            } else {
                self.cityNotSelected = true;
                self.loading = false;

                iziToast.show({
                    title: this.not_location_selected,
                    color: 'red' // blue, red, green, yellow
                });
            }
        },
        getAddressData: function (addressData) {
            this.address = addressData;
            this.cityNotSelected = false;
        },
        openMenu() {
            this.menu_open = true;
        },
        closeMenu() {
            let self = this;

            setTimeout(function () {
                self.menu_open = false;
            }, 100);
        },
        setKeyword(keyword) {
            this.closeMenu();
            this.selected_keyword = keyword;
            this.$refs.keyword_input.focus();
        },
        getKeywordAutoComplete() {
            let self = this;

            let requestedType = 'keywords';

            if (!self.selected_keyword) {
                requestedType = 'categories';
            }

            if (!self.selected_keyword && self.suggested_searches.length > 0) {
                self.keywords_loading = false;
                return;
            }

            axios.get(`${this.auto_complete_route}?search_query=${this.selected_keyword}&requested_type=${requestedType}`)
                .then(function (response) {

                    if (requestedType === 'keywords') {
                        self.keywords = response.data.results;
                    } else if (requestedType === 'categories') {
                        self.suggested_searches = response.data.results;
                    }

                    self.keywords_loading = false;
                })
                .catch(function (error) {
                    self.keywords_loading = false;
                });
        },
        clearFields: function () {
            window.location.href = this.restaurant_route;
        },
        removeSearch(search) {
            let self = this;

            if (search.type === 'city') {

                this.searchLists = this.searchLists.filter(function (obj) {
                    return obj.type !== 'range';
                });

                this.eventHub.$emit('reset_range');
                this.search_range = '';

                this.eventHub.$emit('reset_city');
                this.address = [];
            }

            if (search.type === 'amenities') {
                this.eventHub.$emit('reset_amenity', search);
            }

            if (search.type === 'terms') {
                this.eventHub.$emit('reset_term', search);
            }

            if (search.type === 'keyword') {
                this.eventHub.$emit('reset_keyword');
                this.selected_keyword = '';
            }

            if (search.type === 'range') {
                this.eventHub.$emit('reset_range');
                this.search_range = '';
            }

            if (search.type === 'rating') {
                this.eventHub.$emit('reset_rating', search.value);
            }

            this.searchLists = this.searchLists.filter(function (obj) {
                return obj.value != search.value;
            });

            if (this.searchLists.length > 0) {
                this.makeSearch();
            } else {
                window.location.href = self.restaurant_route;
            }
        },
        setSearchedList() {
            this.searchLists = this.getUserSearchSession();
        },
        setSearchedCity() {
            let city = this.getUserSearchSessionByType('city');

            if (city.length > 0) {
                this.address = city[0].value;
                this.city_placeholder = this.address.locality;
            }
        }
    },
    created() {
        this.getKeywordAutoComplete = debounce(this.getKeywordAutoComplete, this.delay);

        let self = this;

        this.eventHub.$on('rating-ticked', rating => {
            self.search_rating = rating;
        });

        this.eventHub.$on('range-ticked', range => {
            self.search_range = range;
        });

        this.eventHub.$on('term-ticked', terms => {
            self.search_terms = terms;
        });

        this.eventHub.$on('amenity-ticked', amenities => {
            self.search_amenities = amenities;
        });

        this.eventHub.$on('execute-search', form_type => {
            self.makeSearch(form_type);
        });
    },
    mounted() {
        this.setSearchedList();
        this.setSearchedCity();
    }
}
</script>

<style>
.suggested_search {
    height: 40px;
    display: flex;
    align-items: center;
    background: rgba(189, 189, 189, 0.13);
    color: #696969;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.18);
}

.suggested_search:hover {
    background: rgba(130, 130, 130, 0.15);
    cursor: pointer;
}

.suggested_search_holder {
    margin-bottom: 10px;
}

.suggested_search_holder:last-child {
    margin-bottom: 20px;
}

.search_results {
    background: #ffffff;
    border: 1px solid #e9e9e9;
    border-top-width: 0;
    position: absolute;
    z-index: 99;
    left: 0 !important;
    right: 0 !important;
}

.separator_text {
    margin-bottom: 10px;
    margin-top: 10px;
}

.single_search_result {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 8px 15px;
    margin-left: 0;
    margin-right: 0;
}

.single_search_result:hover {
    background: rgba(130, 130, 130, 0.15);
    cursor: pointer;
}

.no_results_message {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
}

.svg-loader {
    width: 50px;
    margin-top: 20px;
    margin-bottom: 20px;
}

@media (max-width: 767px) {
    .filter-actions.filter-column {
        flex-direction: row;
        row-gap: 16px;
    }
}

@media (max-width: 1740px) {
    #div-show-map {
        display: none !important;
    }
}

.btn-filter {
    background-color: #fff;
    border: 1px solid #7F9741;
    color: #7F9741;
}

.btn-filter:hover,
.btn-filter:focus {
    color: #7F9741;
}

.btn-filter:after {
    content: none;
}

.btn-filter .lnr {
    color: #7F9741;
    font-size: 12px;
    margin-left: 5px;
}

.btn-search-list {
    background-color: transparent;
    border: 1px solid #000000;
    color: #000000;
    padding: 5px 10px;
    cursor: auto;
    transition: all .2s ease-in-out;
    margin-right: 20px;
    margin-bottom: 4px;
}

.btn-search-list:focus {
    outline: none;
}

.btn-search-list:active {
    box-shadow: none;
}

.btn-search-list:after {
    content: none;
}

.btn-search-list span.lnr {
    vertical-align: middle;
    cursor: pointer;
}

.btn-search-list span.lnr:hover {
    border-radius: 50%;
    background-color: #7F9741;
    color: #fff;
}

.btn-search-list:hover {
    border-color: #7F9741;
    color: #7F9741;
}

.btn-search-list .search-list-label {
    font-size: 14px;
    display: inline;
}

.btn-primary.sidebar-w-100 {
    margin-top: 8px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/RestaurantSearch.vue